<template>
    <h1 v-if="logo" class="logo" :style="{ backgroundImage: (!logo ? null : `url(${logo})`) }">{{ title }}</h1>
    <keep-alive>
        <component v-if="$state.tipo" :is="$state.tipo" />
    </keep-alive>
</template>

<script>
import { numbers, percentage, sort, watcher, logger } from '@/core/utils'
import { fetch } from '@/core/api'
import config from '@/core/config'
import map from '@/core/map'
import utils from './utils'
import analytics from '@/core/analytics'

export default {
    data: () => ({
        delay: null,
        main: false
    }),
    mounted() {
        this.autorefresh();
    },
    methods: {
        fetch(local, ano) {
            const slug = `${utils.slugger(this.$state, local, ano)}`;
            slug && !slug.includes('990000') && fetch(slug)
        },
        autorefresh() {
            if (!this.$state.realtime) return;
            this.delay = setTimeout(() => {
                logger('autorefresh')
                this.update();
                this.autorefresh();
            }, config.autorefresh);
        },
        update(comparar) {
            if (!this.slug) return;
            this.$state.slug = this.slug;
            let required = ['500000'];
            ['legislativas', 'europeias'].includes(this.$state.tipo) && required.push('600000');
            let codes = this.global || this.$state.lite ? required : [];
            const code = this.prepare(`${this.$state.local.slice(0, 4)}00`);
            !codes.includes(code) && codes.push(code);
            if (!this.main) {
                this.main = true;
                required.forEach(item => (!codes.includes(item) && codes.push(item)));
            }
            logger('update codes', codes)
            if (!codes.length) return;
            codes.forEach(local => this.fetch(local))
            if (comparar) {
                const ano = !this.$state.lite ? this.$state.comparar : null;
                ano && codes.forEach(local => !utils.data(this.$state, utils.slugger(this.$state, this.prepare(local), ano)) && this.fetch(local, ano));
            }
        },
        prepare(value) {
            if (!value) return;
            const code = `${value}`;
            const char = parseInt(code.charAt(0));
            return ![3, 4].includes(char) || !code.endsWith('0000') || !parseInt(code.charAt(1)) ? value : `${char}00000`;
        }
    },
    computed: {
        logo() {
            return this.$state.view || this.$state.eleicoes || !this.$state.tipo || !this.$state.ano ? null : `${config.assets}/${this.$state.widget}/${this.$state.tipo}/${this.$state.ano}/logo${!this.$win.dark ? '' : '-dark'}.png`;
        },
        title() {
            return `${config.widgets.eleicoes.title || ''} ${!this.$state.tipo || !config.widgets.eleicoes.tipos[this.$state.tipo] ? '' : (config.widgets.eleicoes.tipos[this.$state.tipo].title || '')} ${this.$state.ano || ''}`;
        },
        slug() {
            return !this.$state || !this.$state.local ? null : utils.slugger(this.$state);
        },
        data() {
            if (!this.$state.local) return;
            return !this.global && !this.$state.lite ? utils.data(this.$state, utils.slugger(this.$state, this.prepare(this.$state.local))) : this.legislativas;
        },
        legislativas() {
            return !this.slug ? null : utils.global(this.$state, this.slug);
        },
        global() {
            return !this.$state.local ? true : `${this.$state.local}`.startsWith('99')
        },
        updated() {
            if (!this.data || !this.data.updated_at) return;
            const updated = new Date(this.data.updated_at);
            const date = `${updated.getDate()} ${config.calendar.months[updated.getMonth()]} ${updated.getFullYear()}`;
            let minutes = `${updated.getMinutes()}`;
            if (minutes.length < 2) minutes = !minutes.length ? '00' : `0${minutes}`;
            const time = `${updated.getHours()}:${minutes}`;
            return {
                date,
                time
            }
        },
        freguesias() {
            if (!this.data) return;
            const por_apurar = numbers(this.data.freguesias_por_apurar || 0);
            const total = numbers(this.data.total_de_freguesias);
            const apuradas = numbers(!por_apurar ? total : this.data.freguesias_apuradas || 0);
            const percentagem = percentage(apuradas && apuradas == total ? 100 : (apuradas * 100 / total));
            return {
                apuradas,
                por_apurar,
                total,
                percentagem
            }
        },
        consulados() {
            if (!this.data) return;
            const por_apurar = numbers(this.data.consulados_por_apurar || this.data['consulados por apurar'] || 0);
            const total = numbers(this.data.total_de_consulados || this.data['total de consulados']);
            const apurados = numbers(!por_apurar ? total : this.data.consulados_apurados || this.data['consulados apurados'] || 0);
            const percentagem = percentage(apurados && apurados == total ? 100 : (apurados * 100 / total));
            return {
                apurados,
                por_apurar,
                total,
                percentagem
            }
        },
        mandatos() {
            if (!this.data) return;
            
            const title = this.$state.tipo != 'legislativas' ? 'Cargos Eleitos' : 'Mandatos Atribuidos',
                por_atribuir = parseInt(this.data.mandatos_por_atribuir || 0);

            let atribuidos = 0;

            this.resultados && this.resultados.length && this.resultados.forEach(item => {

                if(!item.mandatos) return;
                
                atribuidos += parseInt(item.mandatos);
            });

            const total = parseInt(atribuidos) + parseInt(por_atribuir),
                percentagem = percentage(atribuidos * 100 / total);

            return {
                title,
                atribuidos,
                por_atribuir,
                total,
                percentagem
            }
        },
        globais() {
            if (!this.data) return;
            const { freguesias, mandatos, legislativas, consulados } = this;
            return {
                freguesias,
                mandatos,
                legislativas,
                consulados
            }
        },
        abstencao() {
            if (!this.data) return;
            const inscritos = parseInt(this.data.inscritos);
            const total = numbers(inscritos);
            const votos = numbers(inscritos - this.total);
            const percentagem = percentage(!total ? 0 : (100 - parseFloat(this.data.percent_votantes || 0)));
            return {
                votos,
                total,
                percentagem
            }
        },
        total() {
            return !this.data ? null : parseInt(this.data.votantes || this.data.votos);
        },
        brancos() {
            if (!this.data) return;
            const total = numbers(this.total);
            const votos = numbers(this.data.brancos);
            const percentagem = percentage(this.data.percent_brancos);
            return {
                total,
                votos,
                percentagem
            }
        },
        nulos() {
            if (!this.data) return;
            const total = numbers(this.total);
            const votos = numbers(this.data.nulos);
            const percentagem = percentage(this.data.percent_nulos);
            return {
                total,
                votos,
                percentagem
            }
        },
        invalidos() {
            if (!this.data) return;
            const { abstencao, brancos, nulos } = this;
            return {
                abstencao,
                brancos,
                nulos
            }
        },
        paint() {
            return utils.painter(this.$state, this.$state.partido);
        },
        resultados() {
            if (!this.data || !this.data.resultados || !this.data.resultados.length) return null;
            let res = parseInt(this.$state.ano) < 2024 || this.global ? [] : [{
                opcao: 'AD',
                //note: 'AD é uma coligação entre PPD, PSD, CDS e PPM em todos os círculos eleitorais, exceto na Madeira (que não inclui PPM).'
            }];
            this.data.resultados.forEach(item => {
                let obj = {
                    ...item
                };
                if (obj.opcao == 'PCP-PEV') obj.opcao = "CDU";
                if (!['PPD/PSD.CDS-PP', 'PPD/PSD.CDS-PP.PPM'].includes(obj.opcao) || parseInt(obj.ano) < 2024 || this.$state.tipo == 'autarquicas') res.push(obj);
                else['mandatos', 'votos', 'percent_votantes'].forEach(prop => {
                    if (!res[0][prop]) res[0][prop] = 0;
                    res[0][prop] += parseFloat(obj[prop]);
                });
            });
            return sort(res, 'percent_votantes', true, true).map(item => {
                const mandatos = parseInt(item.mandatos || 0);
                let right = !this.$state.lite || this.tipo != 'legislativas' ? (`${!mandatos ? '' : numbers(mandatos) + ' eleito' + (mandatos == 1 || mandatos == -1 ? '' : 's') + ' '}${numbers(item.votos) || 0} voto${item.total == 1 || item.total == -1 ? '' : 's'}`) : (numbers(mandatos) || '0');
                return {
                    ...item,
                    left: item.opcao,
                    right,
                    value: item.percent_votantes,
                    bg: utils.cor(item.opcao)
                }
            });
        }
    },
    watch: {
        ...watcher(['data', 'invalidos', 'globais', 'updated', 'resultados', 'paint']),
        slug: {
            immediate: true,
            handler() {
                this.update(this.$state.comparar)
            }
        },
        '$state.local': {
            deep: true,
            handler(local, prev) {
                this.$state.partido = null;
                if (!this.$state.lite && local && config.widgets.eleicoes.tipos[this.$state.tipo]) this.$query.local = local != config.widgets.eleicoes.tipos[this.$state.tipo].local ? local : null;
                local && prev && analytics.pageview('ELECTIONS', `change-location__${local}`);
            }
        },
        '$state.regiao': {
            deep: true,
            handler(regiao) {
                if (!this.$state.lite && regiao) this.$query.regiao = this.$state.regiao != 'CM' ? this.$state.regiao : null;
            }
        },
        '$state.data': {
            deep: true,
            immediate: true,
            handler(res) {
                res && res.children && res.children.forEach(item => {
                    if (!map.locals[item.codigo] && !map.untracked[item.codigo]) map.untracked[item.codigo] = item.nome_do_territorio;
                });
            }
        }
    },
    beforeUnmount() {
        clearTimeout(this.delay);
        this.delay = null;
    }
}
</script>

<style lang="scss" scoped>
.logo {
    text-indent: -99999em;
    overflow: hidden;
    background: 0 0 no-repeat;
    width: 230px;
    height: 80px;
    background-size: contain;
    margin: auto;
    display: block;
    margin-bottom: 2rem;
}
</style>